import { Button } from 'react-bootstrap';

/**
 * Submit button for the user editor pages.
 * The Admin / Service Manager / Deployment Manager checkboxes are now
 * rendered in the parent page as a stacked group next to this button.
 * @param {{onSubmit: (), disabled: boolean, title?: string}}
 * @returns
 */
export default function UserEditSubmitButton({ onSubmit, disabled, title = 'Create User' }) {
  return (
    <Button
      variant="primary"
      disabled={disabled}
      className="p-3 h-100"
      onClick={onSubmit}
      style={{ backgroundColor: 'var(--color-secondary)' }}
    >
      {title}
    </Button>
  );
}
